<template>
  <div class="icon-text">
    <img :src="getImg(icon)" />
    {{text}}
  </div>
</template>

<script>
  export default {
    name: 'IconText',
    props: {
      icon: {
        type: String,
        required: true
      },
      text: {
        type: [String, Number]
      }
    },
    methods: {
      getImg (icon) {
        return require(`@/assets/lessons/card/icon-${icon}.svg`)
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "@/styles";
  .icon-text {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    img {
      margin-right: 5px;
    }
  }
</style>